import { Component, Inject, Input, OnInit } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigService,
    HistoryModel,
    NotificationModel,
    ODataLTextModel,
} from '@evorait/pace-core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HISTORY_LONG_TEXT } from '../equipment-history.model';

@Component({
    selector: 'pace-equipment-history-detail',
    templateUrl: './equipment-history-detail.component.html',
    styleUrls: ['./equipment-history-detail.component.scss'],
})
export class EquipmentHistoryDetailComponent implements OnInit {
    @Input() public history: HistoryModel;
    @Input() public notificationModel: NotificationModel;

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public historyAll: ODataLTextModel[];
    public historyError: ODataLTextModel[];
    public historyMaterial: ODataLTextModel[];
    public displayErrorReportsTab: boolean;
    public displayMaterialTab: boolean;
    public dateFormat: string;
    public teamPlayFleetLink: string;
    public showFleetLinkInEquipmentHistory: boolean;
    public notificationType = ConfigConstants.NotificationTypes;
    public constructor(
        public readonly modalInstance: BsModalRef,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly configService: ConfigService,
    ) {
        this.displayErrorReportsTab = this.clientManager.isNgmP58();
        this.displayMaterialTab = this.clientManager.isNgmP58();
        this.dateFormat = this.clientManager.getDateFormat();
        this.showFleetLinkInEquipmentHistory = this.configService.getShowFleetLinkInEquipmentHistory();
    }

    public ngOnInit(): void {
        const url = this.configService.getTeamplayFleetLink();
        const mainEquipment = this.notificationModel.getMainEquipment();
        if (this.showFleetLinkInEquipmentHistory && url.length > 0 && typeof mainEquipment !== 'undefined') {
            // Example: https://fleet.siemens-healthineers.com/equipmentDetails.html?materialNo=7555365&serialNo=57196&country=DE&tab=
            // If Notification type is MS: then after tab "ticketHistory" should get bind "ticketHistory&search=600000640483"
            // If Notification type is other than MS: then after tab "activity" should get bind "activity&search=600000640483"
            const country = this.notificationModel.languageId;
            const params = `?materialNo=${mainEquipment.matnr.value}&serialNo=${mainEquipment.sernr.value}&country=${country}&tab=`;
            this.teamPlayFleetLink = url.concat(params);
        }
        this.setHistoryText();
    }

    public setHistoryText(): void {
        const historySets = this.notificationModel?.historyLongInfo.filter((option) => {
            return this.history?.notificationNo.value === option.NotificationNo;
        });

        this.historyAll = historySets?.length ? historySets : [];
        this.historyError = historySets.filter((history) => {
            return history.TextID === HISTORY_LONG_TEXT.HREP;
        });
        this.historyMaterial = historySets.filter((history) => {
            return history.TextID === HISTORY_LONG_TEXT.HMAT;
        });
    }
}
